
import React, { useState } from 'react';
import './Stories.css';
import { useApp } from '../../context/AppContext';
import CreateStoryModal from '../CreateStoryModal/CreateStoryModal';

const Stories: React.FC = () => {
  const { posts, adminUser, isAdminView } = useApp();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const stories = posts.filter(p => p.isStory);

  return (
    <>
      <div className="stories-container">
        <div className="stories-scroll">
          {isAdminView && (
            <div className="story-item add-story" onClick={() => setShowCreateModal(true)}>
              <div className="story-ring add">
                <div className="add-story-btn">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="5" x2="12" y2="19"/>
                    <line x1="5" y1="12" x2="19" y2="12"/>
                  </svg>
                </div>
              </div>
              <span className="story-name">Add Story</span>
            </div>
          )}
          <div className="story-item has-story">
            <div className="story-ring">
              <img src={adminUser.avatar} alt="My story" />
            </div>
            <span className="story-name">My Story</span>
            {stories.length > 0 && <div className="story-count">{stories.length}</div>}
          </div>
          
          {stories.map((story, i) => (
            <div key={story.id} className="story-item has-story">
              <div className="story-ring">
                <img src={story.mediaUrl} alt={`Story ${i + 1}`} />
              </div>
              <span className="story-name">{i === 0 ? 'Latest' : `${i + 1}h ago`}</span>
            </div>
          ))}
        </div>
      </div>
      
      {showCreateModal && <CreateStoryModal onClose={() => setShowCreateModal(false)} />}
    </>
  );
};

export default Stories;
